export var ConfirmEventType;
(function (ConfirmEventType) {
    ConfirmEventType[ConfirmEventType["Ok"] = 0] = "Ok";
    ConfirmEventType[ConfirmEventType["Cancel"] = 1] = "Cancel";
    ConfirmEventType[ConfirmEventType["Confirm"] = 2] = "Confirm";
    ConfirmEventType[ConfirmEventType["Close"] = 3] = "Close";
})(ConfirmEventType || (ConfirmEventType = {}));
